import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const GET_FUNKTIONSBEREICHE_ROLLEN = '[VorlagenModul] GetFunktionsbereicheRollen laden';
export const GET_FUNKTIONSBEREICHE_ROLLEN_AUSFUEHREN = '[VorlagenModul] GetFunktionsbereicheRollen ausführen';
export const GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH = '[VorlagenModul] GetFunktionsbereicheRollen laden erfolgreich';
export const GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER = '[VorlagenModul] GetFunktionsbereicheRollen Ladefehler';
export const GET_FUNKTIONSBEREICHE_ROLLEN_NICHT_AUSGEFUEHRT = '[VorlagenModul] GetFunktionsbereicheRollen nicht ausgeführt (evtl. Offline)';


export class GetFunktionsbereicheRollenAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenAusfuehrenAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenErfolgreichAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH;
        constructor(public payload: Array<api.FunktionsbereichRollen>, public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenFehlerAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenQueryFunktionsbereicheRollenActions =
    GetFunktionsbereicheRollenAction
    | GetFunktionsbereicheRollenAusfuehrenAction
    | GetFunktionsbereicheRollenErfolgreichAction
    | GetFunktionsbereicheRollenFehlerAction
    | GetFunktionsbereicheRollenNichtAusgefuehrtAction
    ;
